import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/google-play': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M325.3 234.3L104.6 13 385.4 174.2 325.3 234.3zM47 0C34 6.8 25.3 19.2 25.3 35.3V476.6C25.3 492.7 34 505.1 47 511.9L303.6 255.9 47 0zM472.2 225.6L413.3 191.5 347.6 256 413.3 320.5 473.4 286.4C491.4 272.1 491.4 239.9 472.2 225.6zM104.6 499L385.4 337.8 325.3 277.7 104.6 499z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/google-play.js
// module id = 1iR9
// module chunks = 144